<template>
  <div>
    <v-card class="mb-4 rounded elevation-2 border" color="white">
      <!-- Header / Title Section -->
      <v-card-title class="d-flex flex-wrap align-center justify-space-between py-3 px-4 grey lighten-4">
        <div class="d-flex flex-column mb-1 mb-sm-0">
          <div class="text-h6 font-weight-bold" :style="{ color: getThemeColor }">
            <template v-if="selectedProject">
              {{ selectedProject.title || 'Untitled Project' }}
            </template>
            <template v-else>
              {{ getUserCompany?.industry || 'Business' }} Quotes, Billing and Invoicing System
            </template>
          </div>
          
          <div v-if="selectedProject" class="text-caption grey--text text--darken-1 font-weight-medium">
            Ref: {{ selectedProject.reference_number || 'N/A' }}
            <span v-if="selectedProject.client_reference" class="ml-2">
              | Client Ref: {{ selectedProject.client_reference }}
            </span>
          </div>
        </div>

        <!-- Type & Status Chips -->
        <div v-if="selectedProject" class="d-flex align-center flex-wrap gap-2">
          <!-- Project Type Chip -->
          <v-chip
            v-if="selectedProject.type"
            small
            outlined
            color="primary"
            class="font-weight-medium text-capitalize mr-2"
          >
            <v-icon left small>mdi-shape-outline</v-icon>
            {{ formatType(selectedProject.type) }}
          </v-chip>

          <!-- Status Chip -->
          <!-- <v-chip
            v-if="selectedProject.status"
            small
            dark
            :color="getStatusColor(selectedProject.status)"
            class="font-weight-medium text-capitalize"
          >
            <v-icon left small>mdi-clock-outline</v-icon>
            {{ selectedProject.status.replace('_', ' ') }}
          </v-chip> -->
          <!-- Print Invoice Button -->
          <div class="d-flex align-center flex-wrap gap-2 mt-2 mt-sm-0" v-if="selectedProject">
            <v-chip
              color="primary"
              variant="tonal"
              size="small"
              class="font-weight-medium"
              prepend-icon="mdi-text-short"
            >
              <span class="text-truncate" style="max-width: 300px;">
                <ProFormaGenerator :invoice="selectedProject" 
                :title="selectedProject.invoice_number ? 'Invoice' : 'Quotation'" 
                :buttunWithText="true"></ProFormaGenerator>
              </span>
            </v-chip>
          </div>
        </div>
      </v-card-title>

      <v-divider></v-divider>

      <!-- Details Grid -->
      <v-card-text v-if="selectedProject" class="py-3 px-4">
        <v-row dense>
          <!-- Billing Type & Budget -->
          <v-col cols="12" sm="6" md="3">
            <div class="text-caption grey--text text--darken-1">Billing & Budget</div>
            <div class="text-body-2 font-weight-medium">
              <v-icon small class="mr-1 grey--text">mdi-cash-multiple</v-icon>
              {{ formatBillingType(selectedProject.billing_type) }} 
              <span class="grey--text text--darken-1">
                ({{ formatCurrency(selectedProject.budget_amount) }})
              </span>
            </div>
          </v-col>

          <!-- Billed Amount Progress -->
          <v-col cols="12" sm="6" md="3">
            <div class="text-caption grey--text text--darken-1">Billed Amount</div>
            <div class="text-body-2 font-weight-medium">
              <v-icon small class="mr-1 grey--text">mdi-receipt-text-outline</v-icon>
              {{ formatCurrency(selectedProject.billed_amount) }}
            </div>
          </v-col>

          <!-- Location / Venue -->
          <v-col cols="12" sm="6" md="3">
            <div class="text-caption grey--text text--darken-1">{{ locationLabel }}</div>
            <div class="text-body-2 font-weight-medium text-truncate">
              <v-icon small class="mr-1 grey--text">mdi-map-marker-outline</v-icon>
              {{ selectedProject.location || 'Not Specified' }}
            </div>
          </v-col>

          <!-- Dates / Timeline -->
          <v-col cols="12" sm="6" md="3">
            <div class="text-caption grey--text text--darken-1">Dates</div>
            <div class="text-body-2 font-weight-medium">
              <v-icon small class="mr-1 grey--text">mdi-calendar-range</v-icon>
              {{ selectedProject.start_date || 'N/A' }} 
              <span v-if="selectedProject.due_date">to {{ selectedProject.due_date }}</span>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ProFormaGenerator from '@/modules/CaseManager/ProFormaGenerator.vue'

export default {
  name: 'ProjectDetailHeader',
  props: {
    selectedProject: {
      type: Object,
      default: null
    }
  },
  components:{
    ProFormaGenerator
  },
  data: () => ({
    matterLabel: "project"
  }),
  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor
    },
    getUserCompany() {
      return this.$store.getters.getUserCompany
    },
    getCurrency() {
      return this.$store.getters.getCurrency
    },
    getAppMode(){
      return this.$store.getters.getAppMode
    },
    locationLabel(){
      return this.getAppMode === 'projects' ? 'Site' : 'Venue'
    }
  },
  methods: {
    getStatusColor(status) {
      const colors = {
        draft: 'grey darken-1',
        scheduled: 'info',
        in_progress: 'primary',
        on_hold: 'warning',
        completed: 'success',
        cancelled: 'error'
      }
      return colors[status] || 'primary'
    },
    formatType(type) {
      return type ? type.replace('_', ' ') : ''
    },
    formatBillingType(type) {
      if (!type) return 'Fixed Price'
      return type.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
    },
    formatCurrency(val) {
      const num = Number(val);
        
        // Guard against null, undefined, NaN, or non-numeric strings
        if (isNaN(num)) {
          return `${this.getCurrency || ''} 0.00`.trim();
        }

        return `${this.getCurrency || ''} ${num.toFixed(2)}`.trim();
    }
  }
}
</script>